import axios from "axios";
import secureLocalStorage from "react-secure-storage";
const getBaseURL = () => {
  const baseURL = secureLocalStorage.getItem("baseURL");
  if (!baseURL) {
    throw new Error("Base URL not set in secureLocalStorage!");
  }
  return baseURL;
};
export const get_active_locations_api = async () => {
  const baseURL = getBaseURL();
  try {
    const response = await axios.get(`${baseURL}/api/active-locations`);
    // API returns: { status: true, message: "...", data: [...] }
    if (response.data && typeof response.data.status === 'boolean' && Array.isArray(response.data.data)) {
        // Normalize to { success, data, message }
        return {
            success: response.data.status, // Use 'status' from API as 'success'
            data: response.data.data,
            message: response.data.message
        };
    }
    // Fallback if structure is different (you can add more specific checks if needed)
    console.error("Unexpected API response structure for locations:", response.data);
    throw new Error("Invalid data structure from locations API.");
  } catch (error:any) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch locations';
    console.error("Error fetching active locations:", errorMessage, error.response?.data || error);
    throw new Error(errorMessage);
  }
};
export const get_active_departments_api = async () => {
  const baseURL = getBaseURL();
  try {
    const response = await axios.get(`${baseURL}/api/active-departments`);
    // Assuming departments API has a similar structure { status: true, message: "...", data: [...] }
    if (response.data && typeof response.data.status === 'boolean' && Array.isArray(response.data.data)) {
        // Normalize to { success, data, message }
        return {
            success: response.data.status, // Use 'status' from API as 'success'
            data: response.data.data,
            message: response.data.message
        };
    }
    // Fallback
    console.error("Unexpected API response structure for departments:", response.data);
    throw new Error("Invalid data structure from departments API.");
  } catch (error:any) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch departments';
    console.error("Error fetching active departments:", errorMessage, error.response?.data || error);
    throw new Error(errorMessage);
  }
};
export const get_all_coming_birthdays = async (startDate, endDate) => {
  const response = await axios.post(`${getBaseURL()}/api/upcoming-birthdays`, {
    from_date: startDate,
    to_date: endDate,
  });
  return response.data;
};
export const get_all_coming_holidays = async (startDate, endDate) => {
  const response = await axios.post(`${getBaseURL()}/api/upcoming-holidays`, {
    from_date: startDate,
    to_date: endDate,
  });
  return response.data;
};
export const get_todays_leave_report = async () => {
  const response = await axios.get(`${getBaseURL()}/api/get-leave-Report-according-to-leave-policy`);
  return response.data;
};

export const get_all_attendance_feed = async () => {
  const response = await axios.get(`${getBaseURL()}/api/attendance-feed`);
  return response.data;
};
export const get_unapproved_leaves = async (userId) => {
  const response = await axios.post(`${getBaseURL()}/api/get-approval-waiting-leaves`, {
    user_id: userId,
  });
  return response.data;
};
export const add_employee_attendance = async (userid,shiftId, dateTime, attendanceId, notes) => {
  const response = await axios.post(`${getBaseURL()}/api/employee-attendance`, {
    user_id:userid,
    shift_id: shiftId,
    employee_attendance_notes: notes,
    attendance_type_id: attendanceId,
    attendance_datetime: dateTime,
  });
  return response.data;
};
export const add_attendance = async (shiftId, dateTime, attendanceId, notes) => {
  const response = await axios.post(`${getBaseURL()}/api/add-attendance-by-employee`, {
    shift_id: shiftId,
    attendance_type_id: attendanceId,
    attendance_datetime: dateTime,
    employee_attendance_notes: notes,
  });
  return response.data;
};
export const add_attendance_shifts = async (payload) => {
  const response = await axios.post(`${getBaseURL()}/api/add-attendance-by-employee`,payload);
  return response.data;
};
export const get_current_employee_attendance = async () => {
  const response = await axios.get(`${getBaseURL()}/api/employee-attendance`);
  return response.data;
};
// Announcements
export const add_announcements = async (values) => {
  const response = await axios.post(`${getBaseURL()}/api/announcement`, values);
  return response.data;
};
export const get_all_announcements = async () => {
  const response = await axios.get(`${getBaseURL()}/api/active-announcement`);
  return response.data;
};
export const get_all_announcements_last_five = async () => {
  const response = await axios.get(`${getBaseURL()}/api/announcements/last-five`);
  return response.data;
};
export const delete_announcements = async (id) => {
  const response = await axios.delete(`${getBaseURL()}/api/announcement/${id}`);
  return response.data;
};
export const update_announcements = async (id, data) => {
  const response = await axios.patch(`${getBaseURL()}/api/announcement/${id}`,data
  );
  return response.data;
};
export const get_single_announcements_log = async (id) => {
  const response = await axios.get(`${getBaseURL()}/api/single-announcement-log/${id}`);
  return response.data;
};
export const get_all_announcements_logs = async () => {
  const response = await axios.get(`${getBaseURL()}/api/all-announcements-logs`);
  return response.data;
};